import React from 'react';
import { Table } from '@tanstack/react-table';
import { RxChevronLeft, RxChevronRight } from 'react-icons/rx';

import styles from './paginationButtons.module.scss';

interface PaginationButtonsProps<TData> {
	table: Table<TData>;
}

export function PaginationButtons<TData>({ table }: PaginationButtonsProps<TData>) {
	const currentPage = table.getState().pagination.pageIndex + 1;
	const totalPages = table.getPageCount();

	const renderPageButtons = () => {
		let leftPage = currentPage - 1;
		let middlePage = currentPage;
		let rightPage = currentPage + 1;

		// Handle first and last page
		if (currentPage === 1) {
			leftPage = 1;
			middlePage = 2;
			rightPage = 3;
		} else if (currentPage === totalPages) {
			leftPage = totalPages - 2;
			middlePage = totalPages - 1;
			rightPage = totalPages;
		}

		return (
			<>
				{leftPage > 0 && (
					<button
						onClick={() => table.setPageIndex(leftPage - 1)}
						className={[styles.pageButton, currentPage === leftPage ? styles.active : ''].join(' ')}
					>
						{leftPage}
					</button>
				)}
				{middlePage <= totalPages && (
					<button
						onClick={() => table.setPageIndex(middlePage - 1)}
						className={[styles.pageButton, currentPage === middlePage ? styles.active : ''].join(
							' ',
						)}
					>
						{middlePage}
					</button>
				)}
				{rightPage <= totalPages && (
					<button
						onClick={() => table.setPageIndex(rightPage - 1)}
						className={[styles.pageButton, currentPage === rightPage ? styles.active : ''].join(
							' ',
						)}
					>
						{rightPage}
					</button>
				)}
			</>
		);
	};

	return (
		<div className={styles.paginationContainer}>
			<button
				onClick={() => table.previousPage()}
				disabled={!table.getCanPreviousPage()}
				className={styles.arrowButton}
			>
				<RxChevronLeft />
			</button>
			{renderPageButtons()}
			<button
				onClick={() => table.nextPage()}
				disabled={!table.getCanNextPage()}
				className={styles.arrowButton}
			>
				<RxChevronRight />
			</button>
		</div>
	);
}
